import { Firestore } from "../lib/firebase";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { sortArrayPipe } from "shared/pipes";

toast.configure({
  autoClose: 2000,
  draggable: false
});
const SIZE_TABLE_NAME = "sizes";

export function getSize() {
  return Firestore.collection(SIZE_TABLE_NAME)
    // .where("market", "==", country)
    .get()
    .then((results) => results.docs.map((size) => size.data()))
    .catch((error) => {
      throw new Error(error);
    });
}
export async function getSizesById(id) {
  try {
    return Firestore.collection(SIZE_TABLE_NAME)
    .doc(id)
    .get()
    .then((docRef) => { return docRef.data() })
      .catch((error) => { 
        throw new Error(error);
    })
  
} catch (error) {
  throw error;
}
}

export function deleteSizesById(id, setData,isDeleting,setIsDeleting) {

  if (isDeleting) {
    return;
  }

  setIsDeleting(true);

  const docRef = Firestore.collection(SIZE_TABLE_NAME).doc(id);

  docRef.delete()
    .then(() => {
      setData(prevData => prevData.filter(item => item.id !== id));
      toast.success("Size deleted successfully!", {
        position: toast.POSITION.TOP_LEFT
      });
    })
    .catch((error) => {
      console.error("Error removing document: ", error);
    })
    .finally(() => {
      setIsDeleting(false);
    });
}

export const create = async (payload,setData,inputText,setInputText,id,setIsLoading,isLoading) => {
  try {

     // Check if already loading or if an error has occurred
     if (isLoading) {
      return;
    }
    setIsLoading(true); 
    const loadingFunc = () => {
      setIsLoading(false)
    }

      // Check if the garment value already exists in Firestore
      const existingDoc = await Firestore.collection(SIZE_TABLE_NAME)
      .where('value', '==', payload.value)
      .get();
  
    if (!existingDoc.empty) {
      toast.error("Size already exists", {
        position: toast.POSITION.TOP_LEFT
      });
      setTimeout(loadingFunc, 2000);

      return;
    }

      await Firestore.collection(SIZE_TABLE_NAME).doc(payload.id)
      .set(payload)
      .then(() => {
        setData(prevData => [...prevData, { id: id, value: inputText, label: inputText }]);
        setInputText("");
        setTimeout(loadingFunc, 2000);
        toast.success("Size created successfully!", {
          position: toast.POSITION.TOP_LEFT
      });
    })
    
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};
export const update = async (payload,history) => {
  try {
    // Check if the garment value already exists in Firestore
    const existingDoc = await Firestore.collection(SIZE_TABLE_NAME)
      .where('value', '==', payload.value)
      .get();

    if (!existingDoc.empty) {
      toast.error("Size already exists", {
        position: toast.POSITION.TOP_LEFT
      });
      return;
    }

    await Firestore.collection(SIZE_TABLE_NAME)
      .doc(payload.id)
      .set(payload)
      .then(() => {
        history.goBack()
        toast.success("Size updated successfully!", {
          position: toast.POSITION.TOP_LEFT
        });
      });
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};

// export function getMindCondition() {
//   return Firestore.collection(MIND_CONDITION_TABLE_NAME)
//     // .where("market", "==", country)
//     .get()
//     .then((results) => results.docs.map((mindCondition) => mindCondition.data()))
//     .catch((error) => {
//       throw new Error(error);
//     });
// }


// const AVAILABLE_SIZES = [
//   { value: "XS/34", label: "XS/34", code: "XS" },
//   { value: "S/36", label: "S/36", code: "S" },
//   { value: "M/38/40", label: "M/38/40", code: "M" },
//   { value: "L/42", label: "L/42", code: "L" },
//   { value: "XL/44", label: "XL/44", code: "XL" },
//   { value: "XXL/46", label: "XXL/46", code: "XXL" },
//   { value: "XXXL/48", label: "XXXL/48", code: "XXXL" },
//   { value: "ONESIZE", label: "ONESIZE", code: "OS" }
// ];

/**
 * Return an array of objects
 */
// export function getSize() {
//   return Firestore.collection(SIZE_TABLE_NAME)
//   // .where("market", "==", country)
//   .get()
//   .then((results) => results.docs.map((size) => size.data()))
//   .catch((error) => {
//     throw new Error(error);
//   });}

async function dataStream(callback) {
  const brands = await getSize();
  callback(sortArrayPipe.transform(brands, 'value'));
}



export async function getSizeByValue(sizeValue)  {
  if (dataStream) {
    await dataStream((values) => {
      return values.find((size) => size.value === sizeValue);
    });
  }
  
}
